/* eslint-disable import/no-anonymous-default-export */
import { Checkbox, Form, Input, Select } from "antd";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import DataSave from "../../common/components/DataSave";
import MainLayout from "../../common/components/MainLayout";
import { ActionResult } from "../../common/hooks/useApi";
import useRolesAPI, { Rol } from "../../roles/useRolesAPI";
import useUsuariosAPI, { Usuario, UsuarioSave } from "../useUsuariosAPI";
import useConveniosPagoConfiguracionesAPI, { ConveniosPagoConfiguracion } from "../../convenios-pago-configuraciones/useConveniosPagoConfiguracionesAPI";


export default () => {
    const { id } = useParams();
    const api = useUsuariosAPI();
    const rolesApi = useRolesAPI();
    const conveniosPagoConiguracionesApi = useConveniosPagoConfiguracionesAPI();

    const [rolesResponse, setRolesResponse] = useState<ActionResult<Rol[]>>();
    const [conveniosPagoConfiguracionesResponse, setConveniosPagoConfiguracionesResponse] = useState<ActionResult<ConveniosPagoConfiguracion[]>>();
    const [selectedRol, setSelectedRol] = useState<{ id: number | null, nombre: string | null }>({ id: null, nombre: null });
    const isEditMode = id ? true:false;
    const successRoute = "/usuarios";

    useEffect(() => {
        rolesApi
            .list({ $top: 200 })
            .then((result) => {
                setRolesResponse(result);
            });
        conveniosPagoConiguracionesApi
            .list({ $top: 10000 })
            .then(setConveniosPagoConfiguracionesResponse)
    }, []);

    const handleSelectRolChange = (val: number) => {
        const selected = rolesResponse?.data?.value.find((rol) => rol.Id === val);
        setSelectedRol({ id: val, nombre: selected?.Nombre ?? null });
    }

    return (
        <MainLayout title= {(isEditMode ?'Editar':"Guardar") + " usuario"}>
            <DataSave<Usuario, UsuarioSave, UsuarioSave>
                list={api.list}
                save={api.save}
                successRoute={successRoute}
                itemQuery={{ $expand: ["Role"] }}
                onChange={(data)=>data.Rol && handleSelectRolChange(data.Rol)}
                transformOnLoad={async (value) => ({ ...value, ...{ Rol: value.Role.Id } })}
                transformOnSave={async (value) => {
                    const newValue = { ...value };
                    newValue.JuzgadoConfiguracionId = Number(newValue.JuzgadoConfiguracionId);
                    if (Array.isArray(newValue.IdentificadoresEquipoJuzgado)) {
                        newValue.IdentificadoresEquipoJuzgado = newValue.IdentificadoresEquipoJuzgado.join();
                    }                    
                    return newValue;
                }}
                id={id}
            >
                <Form.Item
                    rules={[
                        { required: true, message: "Campo requerido" }
                    ]}
                    required
                    name={"Nombre"}
                    label="Nombre">
                    <Input />
                </Form.Item>

                <Form.Item
                    rules={[
                        { required: true, message: "Campo requerido" }
                    ]}
                    required
                    name={"Apellido"}
                    label="Apellido">
                    <Input />
                </Form.Item>

                <Form.Item
                    rules={[
                        { required: true, message: "Campo requerido" }
                    ]}
                    required
                    name={"NombreUsuario"}
                    label="Nombre de usuario">
                    <Input />
                </Form.Item>

                <Form.Item
                    rules= {[
                        { required: !isEditMode, message: "Campo requerido" }
                    ]}
                    //required
                    tooltip="Dejar en blanco para no cambiarla"
                    name={"Contrasena"}
                    label="Contraseña"                    
                    >                        
                    <Input.Password autoComplete = "new-password"/>
                </Form.Item>

                <Form.Item
                    rules={[
                        { required: true, message: "Campo requerido" }
                    ]}
                    required
                    name={"Rol"}
                    label="Rol">
                    <Select
                        loading={!rolesResponse}
                        allowClear
                    >
                        {rolesResponse?.data?.value
                            .map((rol) =>
                                <Select.Option key={rol.Id} value={rol.Id}>
                                    {rol.Nombre}
                                </Select.Option>
                            )}
                    </Select>
                </Form.Item>

                {selectedRol.id == 175 &&
                    <Form.Item
                        required
                        name={"ConveniosPagoConfiguracionId"}
                        label="Configuración de convenios"
                        help="Seleccione la configuración que va a utilizar el usuario para generar los convenios"
                    >
                        <Select>
                            {conveniosPagoConfiguracionesResponse?.data?.value.map(c => <Select.Option value={c.Id}>{c.Nombre}</Select.Option>)}
                        </Select>
                    </Form.Item>}

                {
                    (selectedRol.nombre === "Juzgado" || selectedRol.nombre === "Cobranzas") && (
                        <Form.Item
                            help={"Ingrese el Id de la Configuración de Juzgado que quiere visualizar las infracciones en el módulo de Juzgado, Por ej: '1' "}
                            name={"JuzgadoConfiguracionId"}
                            label="Identificador configuracion Juzgado"
                        >
                            <Input type = "number" size = "middle" style = { { width: "20%" } } />
                        </Form.Item>
                    )
                }
                {
                    (selectedRol.nombre === "Gestor municipio") && (
                        <Form.Item
                            help = { "Ingresar los Id's de los equipos asociados al Municipio que quiere visualizar las infracciones, Por ej: '2','5'" }
                            name = { "IdentificadoresEquipoJuzgado" }
                            label = "Identificadores equipos juzgado"
                        >
                            <Select
                                mode = "tags"
                                notFoundContent = "Ingrese uno o mas Ids de equipos"
                                allowClear
                                style = {{ width: '250px' }}
                                placeholder = "Ingrese uno o mas Ids de equipos.."
                                options = {[]}                                
                            />
                        </Form.Item>
                    )
                }

                        <Form.Item
                            name="Deshabilitado"
                            valuePropName="checked"
                            tooltip="Puede habilitar/deshabilitar la cuenta temporalmente"
                            //wrapperCol={{ offset: 8, span: 16 }}
                            >
                                <Checkbox>Deshabilitar usuario</Checkbox>
                        </Form.Item>
                        
            </DataSave>
        </MainLayout>
    );
};